import { useEffect, useState } from "react";
import { useSetRecoilState } from "recoil";
import MomSysMaterialByCompanyCreateButton from "../input/MomSysMaterialByCompanyCreateButton";
import MomSysMaterialByCompanyUpdateButton from "../input/MomSysMaterialByCompanyUpdateButton";
import { Tooltip, toggleClass, escapeHtml, } from '@grapecity/wijmo';
import "./gridEvent.css"

import getSchema from "../../lib/api/getSchema";
import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";
import BasicCrudScreenActionItemLayout from "../screenTypes/layout/BasicCrudScreenActionItemLayout";
import AccessControl from "../functional/AccessControl";
import notificationState from "../../states/notificationState";
import DeleteRecordButton from "../input/DeleteRecordButton";
import DataAllSaveToExcelButton from "../input/DataAllSaveToExcelButton";
import FlexCrudScreenType from "../screenTypes/functional/FlexCrudScreenType";
import CustomRecordButton from "../input/CustomRecordButton";

function KonamMaterialByCompany ( props ) {

    const {
        select,
        materialGrid
    } = props;
    const id = "KonamMaterialByCompany";

    const [schema, setSchema] = useState();
    const [api, setApi] = useState();
    const [grid, setGrid] = useState();
    const [selectGrid, setSelectGrid] = useState();

    const setNotification = useSetRecoilState(notificationState);

    useEffect( ()=> {

        let mounted = true;

        (async ()=> {
            
            let schema = await getSchema("MomSysMaterialByCompany");

            for(let column of schema.columns){
                switch(column.name) {
                    case "companyCode":
                        column.key = "";
                        break;
                    default:
                        break;
                }
            }
            if ( mounted ) {

                setSchema(schema);

            }

        })();

        return ( () => {

            mounted = false;

        } );

    },[]);

    useEffect(()=>{
        if(select && api){
            api.refresh();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[select]);

    useEffect(() => {
        let tooltip = new Tooltip();
        (async () => {
            if (grid) {
                grid.formatItem.addHandler((flex, element) => {
                    if (element.panel === flex.cells) {
                        let item = flex.rows[element.row].dataItem
                        let binding = flex.columns[element.col].binding
                        let data = item.description ? item.description : null;
                        toggleClass(element.cell, 'wj-has-notes', binding === "description" && data !== null );
                        if(binding === "description" && data !== null) {
                            // 말풍선은 HTML 로 그리므로 사용자가 적은 값은 글자로 바꿔 넣는다(XSS 방지)
                            tooltip.setTooltip(element.cell, `<h1>${escapeHtml(data)}<h1>`);
                        }
                    }
                });
            }
        })();
        
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [grid]);
    
    useEffect(() => {
        (async () => {
            if (grid) {
                grid.selectionChanged.addHandler((grid, event) => {
                    if (grid.selectedItems && grid.selectedItems[0]) {
                        setSelectGrid(grid.selectedItems[0]);
                    } else {
                        setSelectGrid(undefined);
                    };
                });

                grid.itemsSourceChanged.addHandler((grid, event) => {
                    if (grid.selectedItems && grid.selectedItems[0]) {
                        setSelectGrid(grid.selectedItems[0]);
                    } else {
                        setSelectGrid(undefined);
                    };
                });
            }
        })();
        
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [grid]);
    
    const onApiInitialized = (api) => {
        setApi(api);
    };

    const onInitialized = (grid) => {
        grid.selectionMode = "Row";
        setGrid(grid);
    };

    const notifySuccess = (msg) => {
        setNotification({
            severity: "success",
            msg: msg,
            open: true,
        });
    };

    const notifyFailure = (msg) => {
        setNotification({
            severity: "error",
            msg: msg,
            open: true,
        });
    };
    
    const onSuccess = (msg) => {
        notifySuccess(msg);
    };

    const onFailure = (reason) => {
        notifyFailure(reason.response ? reason.response.data : reason);
    };

    const notifyWarning = (msg) => {
        setNotification({
            severity: "warning",
            msg: msg,
            open: true,
        });
    };

    const onNotifyWarning = (msg) => {
        notifyWarning(msg);
    };

    const onModifyViewUrl = (url)=> {
        if(select?.materialCode){

            let newUrl = `${url}/${select?.materialCode}/${select?.materialCodeVer}`        
            
            return newUrl;
        }
    }

    const modifyInitDataCallback = (initData) => {
        let returnData = {...initData};
        returnData.materialCode = select?.materialCode
        returnData.materialCodeVer = select?.materialCodeVer
        console.log(returnData)
        return returnData;
    }

    const modifyUrlCallback = (url) => {
        if(select?.materialCode){
            return `${url}/${selectGrid?.materialCode}/${selectGrid?.materialCodeVer}/${selectGrid?.companyCode}`
        }
    }   
    const modifyFormDataCallbackOK = (formData) => {
        formData.customerDescription = formData.description        
    }
    return (
        <FlexCrudScreenType
            id={id}
            table="MomSysMaterialByCompany"
            view="KonamVwMaterialByCompany" 
            onInitialized={onInitialized}
            onApiInitialized={onApiInitialized}
            noCreate
            noEdit
            noDelete
            noExcel
            onModifyViewUrl={onModifyViewUrl}
            onAppendButtonInFrontOfSearch={() => (
               <>
                    <BasicCrudScreenActionItemLayout>
                        <AccessControl accessTarget={schema && schema.name} accessMethod="POST">
                            <CustomRecordButton
                                id={id}
                                schema={schema}
                                refresh={api}
                                onSuccess={onSuccess}
                                buttonFullName="buttonName.create"
                                modifyInitDataCallback={modifyInitDataCallback}
                                // checkDisabledCallback={checkDisabledCallback}
                                modifyFormDataCallbackOK={modifyFormDataCallbackOK}
                                mode="edit"
                                method="post"
                                title="create"
                                isFormData
                                disabled={!select?.materialCode}

                            />
                        </AccessControl>

                        <AccessControl accessTarget={schema && schema.name} accessMethod={schema && (schema.updateWithPatch?"PATCH":"PUT")}>
                        <CustomRecordButton
                                id={id}
                                grid={grid}
                                refresh={api}
                                schema={schema}
                                onSuccess={onSuccess}
                                buttonFullName="buttonName.update"
                                mode="edit"
                                method="put"
                                title="update"
                                isFormData
                                modifyUrlCallback={modifyUrlCallback}
                                modifyFormDataCallbackOK={modifyFormDataCallbackOK}
                                disabled={!selectGrid?.materialCode}
                            />
                        </AccessControl>

                        <AccessControl accessTarget={schema && schema.name} accessMethod="DELETE">
                            <DeleteRecordButton
                                id={id}
                                schema={schema}
                                grid={grid}
                                refresh={api}
                                color="secondary"
                                onSuccess={onSuccess}
                                onFailure={onFailure}
                                onPartialFailure={onNotifyWarning}
                                disabled={selectGrid ? false : true}
                            />
                        </AccessControl>

                        <AccessControl accessTarget={schema && schema.name} accessMethod="SAVETOEXCEL" >
                            <DataAllSaveToExcelButton
                                id={id}
                                grid={grid}
                                view="MomSysVwMaterialByCompanyUpdate"
                                excelFileName="거래처별 품목"
                                color="primary"
                                disabled={selectGrid ? false : true}
                            />
                        </AccessControl>
                    </BasicCrudScreenActionItemLayout>
               </> 
            )}
        />
    );

}

export default KonamMaterialByCompany;
